import script from "./NavBarVue.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarVue.vue?vue&type=script&setup=true&lang=js"

import "./NavBarVue.vue?vue&type=style&index=0&id=416121d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-416121d5"]])

export default __exports__